module.exports = __webpack_public_path__ + "static/media/companyservices.bfbb9dda.png";